import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

function NotFound() {
  return (
    <div className="not-found">
      <h1 className="not-found-code">404</h1>
      <p className="not-found-msg">Page not found.</p>
      <Link to="/" className="not-found-link">Back to home</Link>
    </div>
  );
}

export default NotFound;
